import { ArrowRightIcon } from '@heroicons/react/24/solid'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

export default function SignupCTA() {
  return (
    <section
      id="signup-cta"
      aria-label="Try Illuminate Faith for free"
      className="relative overflow-hidden"
      style={{
        // Swapped from candle.png (7.45 MB) to bible-candle.webp (288 KB) —
        // 25x smaller, virtually identical visual at the dimensions used.
        // Per PERF-007.
        backgroundImage: 'url(/bible-candle.webp)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '420px',
      }}
    >
      <div className="absolute inset-0 bg-[#050d1f]/78" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_60%,rgba(233,195,73,0.12)_0%,transparent_65%)] pointer-events-none" />

      <div className="relative z-10 px-4 py-20 md:px-8 md:py-28 text-center">
        <motion.div
          className="mx-auto max-w-xl"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        >
          <h2 className="font-heading text-4xl md:text-5xl font-extrabold text-white leading-tight mb-4">
            Your faith, <span className="text-[var(--gold)]">illuminated.</span>
          </h2>

          <p className="text-white/60 text-lg leading-relaxed mb-8 max-w-md mx-auto">
            Take the first step. Free to start, no card required.
          </p>

          <Link
            to="/login?mode=signup"
            className="inline-flex items-center gap-2 h-12 px-8 rounded-full bg-[var(--gold)] text-[var(--text-on-gold)] font-semibold text-base shadow-lg hover:brightness-110 hover:scale-105 hover:shadow-[0_0_30px_rgba(233,195,73,0.4)] transition-all duration-200"
          >
            Try it for free
            <ArrowRightIcon className="w-4 h-4" aria-hidden="true" />
          </Link>
        </motion.div>
      </div>
    </section>
  )
}
